import { useMemo } from "react";
import { useFetchCampaignLeads } from "@/features/campaigns/hooks/useCampaign";
import { useMainStore } from "@/stores";

// Before a campaign has leads (e.g. while creating it) preview against a complete lead and
// one missing details, so fallbacks are visible up front.
const SAMPLE_LEADS = [
  { id: "sample-complete", full_name: "Alex Morgan", company: "Acme Inc", designation: "Head of Sales", isSample: true },
  { id: "sample-missing", full_name: "", company: "", designation: "", isSample: true },
];

const PREVIEW_LEAD_LIMIT = 200;

/** Leads to preview a message against, plus the sender for {{sender_name}}. */
export default function usePreviewLeads(campaignId) {
  const user = useMainStore((state) => state.user);
  const { data } = useFetchCampaignLeads({
    campaignId,
    limit: PREVIEW_LEAD_LIMIT,
    enabled: Boolean(campaignId),
    refetchInterval: false,
  });

  const leads = useMemo(() => {
    const rows = Array.isArray(data?.leads) ? data.leads : [];
    const mapped = rows
      .filter((lead) => lead?.contact_id)
      .map((lead) => ({
        id: lead.contact_id,
        full_name: lead.full_name ?? "",
        company: lead.company ?? "",
        designation: lead.designation ?? "",
      }));
    return mapped.length ? mapped : SAMPLE_LEADS;
  }, [data]);

  return { leads, sender: { name: user?.name ?? "" }, isSample: leads === SAMPLE_LEADS };
}
